<template>
  <div
    class="header-page"
    :class="{ scrollUp: !showNavbar }"
    :style="{
      backgroundColor: styleHeader.backgroundColor,
      color: styleHeader.color,
      fill: styleHeader.color,
    }"
  >
    <div class="container-v2 inner">
      <div :class="['hamburger', displayMenu ? 'active' : '']">
        <TheSidenav :show="displayMenu" @toggle="showMenu" />
        <div class="d-flex align-items-center style-black" @click="showMenu">
          <div :class="['hamburger-svg', displayMenu ? 'opened' : '']">
            <svg width="40" height="40" viewBox="0 0 100 100">
              <path
                class="line line1"
                d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
              />
              <path class="line line2" d="M 20,50 H 80" />
              <path
                class="line line3"
                d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
              />
            </svg>
          </div>

          <div class="menu">MENU</div>
        </div>
      </div>
      <router-link exact to="/" class="left">
        <div class="img" @click="redirectToHome">
          <svg viewBox="0 0 429 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.9898 40V4.04764H26.5345V10.2515H10.5141V19.8936H25.1392V25.8483H10.5141V40H2.9898ZM36.9141 40.5481C31.0341 40.5481 27.6955 36.786 27.6955 30.5323V13.2911H34.9707V29.0125C34.9707 32.5006 36.6151 34.5187 39.879 34.5187C43.1428 34.5187 45.2108 32.1269 45.2108 28.6388V13.2911H52.486V40H45.2108V35.59H45.0613C43.691 38.6546 40.9503 40.5481 36.9141 40.5481ZM66.827 40.5481C58.6549 40.5481 53.6968 35.2412 53.6968 26.6954V26.6705C53.6968 18.1745 58.7047 12.743 66.5281 12.743C74.3514 12.743 79.2596 18.0499 79.2596 26.1223V28.3647H60.8724C60.9471 32.6252 63.2642 35.1167 66.9765 35.1167C69.9663 35.1167 71.7851 33.4723 72.3083 31.9774L72.3582 31.8279H79.0354L78.9607 32.1019C78.1385 36.0385 74.451 40.5481 66.827 40.5481ZM66.6526 18.1745C63.6628 18.1745 61.4205 20.1677 60.9471 23.7803H72.2834C71.835 20.0929 69.6674 18.1745 66.6526 18.1745ZM80.6449 40V4.04764H87.9201V40H80.6449Z" fill="#090925"/>
            <path d="M113.805 2.5677C113.842 6.16044 113.873 9.7532 113.898 13.3461C113.901 13.7702 113.904 14.1943 113.907 14.6184C113.907 14.745 113.907 14.745 113.908 14.8742C113.918 16.2416 113.931 17.6089 113.946 18.9762C113.96 20.3791 113.971 21.7819 113.979 23.1849C113.984 24.0507 113.991 24.9163 114.003 25.7821C114.01 26.3757 114.014 26.9692 114.015 27.5628C114.016 27.9054 114.018 28.2478 114.025 28.5903C114.031 28.9042 114.032 29.2176 114.03 29.5315C114.031 29.6449 114.032 29.7583 114.036 29.8716C114.056 30.5627 114.056 30.5627 113.92 30.8574C113.685 31.1318 113.386 31.2937 113.085 31.4503C112.914 31.5414 112.754 31.65 112.592 31.7601C112.474 31.8364 112.356 31.9126 112.238 31.9886C112.14 32.052 112.041 32.1154 111.943 32.1789C111.877 32.2219 111.811 32.2648 111.744 32.3077C111.41 32.5239 111.077 32.7418 110.744 32.9601C110.687 32.9977 110.629 33.0352 110.57 33.0739C110.455 33.1497 110.339 33.2254 110.224 33.3011C110.048 33.4164 109.872 33.5316 109.696 33.6467C109.131 34.0163 108.566 34.3867 108.003 34.7596C107.262 35.2494 106.52 35.7348 105.778 36.2202C105.154 36.6282 104.53 37.0368 103.908 37.4486C103.107 37.9783 102.304 38.503 101.501 39.0275C101.383 39.1051 101.264 39.1827 101.145 39.2604C101.059 39.3167 101.059 39.3167 100.971 39.3741C100.523 39.6675 100.077 39.9647 99.6325 40.2651C99.5868 40.2958 99.5411 40.3266 99.494 40.3583C99.4539 40.3854 99.4137 40.4125 99.3724 40.4405C99.2801 40.4982 99.2801 40.4982 99.2239 40.4984C99.2081 39.8168 99.1953 39.1353 99.1864 38.4536C99.1822 38.137 99.1769 37.8205 99.1693 37.504C99.1619 37.1985 99.1573 36.893 99.1546 36.5873C99.1531 36.4708 99.1506 36.3544 99.1471 36.2379C99.1205 35.3264 99.1205 35.3264 99.3187 35.0653C99.4641 34.9616 99.6026 34.8914 99.7632 34.8252C99.8233 34.7851 99.8835 34.745 99.9454 34.7037C99.9977 34.67 100.05 34.6363 100.104 34.6015C100.194 34.5434 100.194 34.5434 100.285 34.4842C100.348 34.4438 100.41 34.4035 100.475 34.362C100.61 34.2745 100.745 34.1869 100.88 34.0993C100.931 34.0665 100.931 34.0665 100.983 34.0331C101.297 33.8292 101.61 33.6225 101.923 33.4151C102.576 32.9822 103.232 32.556 103.889 32.1303C104.208 31.9233 104.528 31.7162 104.847 31.5089C104.909 31.4682 104.972 31.4274 105.037 31.3855C105.515 31.0748 105.993 30.7625 106.47 30.4495C106.779 30.2465 107.089 30.0441 107.4 29.8429C107.434 29.821 107.467 29.7992 107.502 29.7768C107.664 29.6719 107.826 29.5671 107.988 29.4625C108.347 29.2299 108.702 28.9912 109.054 28.7443C109.187 28.6601 109.187 28.6601 109.299 28.6596C109.291 26.5946 109.283 24.5296 109.274 22.402C108.498 22.8932 107.728 23.3852 106.962 23.8942C106.632 24.1124 106.298 24.3236 105.964 24.5338C105.52 24.8136 105.078 25.0988 104.639 25.3905C104.198 25.6836 103.755 25.9739 103.31 26.2596C103.231 26.3109 103.231 26.3109 103.15 26.3633C103.101 26.3944 103.053 26.4256 103.002 26.4576C102.959 26.4852 102.917 26.5127 102.872 26.5411C102.767 26.5999 102.767 26.5999 102.654 26.6003C102.647 24.858 102.64 23.1156 102.633 21.3204C103.114 21.0174 103.595 20.7143 104.091 20.402C104.576 20.0822 104.576 20.0822 105.06 19.7611C105.452 19.5019 105.848 19.2523 106.244 19.0025C106.573 18.7947 106.902 18.5856 107.229 18.3728C107.268 18.3476 107.307 18.3225 107.346 18.2966C107.601 18.1309 107.854 17.9637 108.108 17.7961C108.172 17.7539 108.236 17.7117 108.302 17.6681C108.429 17.5842 108.556 17.5001 108.683 17.4157C108.74 17.3777 108.798 17.3396 108.858 17.3004C108.909 17.2661 108.961 17.2318 109.014 17.1965C109.14 17.1226 109.14 17.1226 109.252 17.1221C109.237 13.2932 109.221 9.46435 109.205 5.51943C109.982 5.00005 109.982 5.00005 110.776 4.47019C111.091 4.25913 111.091 4.25913 111.407 4.04803C111.657 3.88093 111.907 3.71418 112.157 3.54739C112.347 3.42055 112.536 3.2931 112.726 3.16556C112.843 3.08674 112.961 3.00792 113.079 2.92913C113.133 2.89251 113.187 2.85589 113.243 2.81817C113.292 2.78513 113.342 2.7521 113.393 2.71806C113.436 2.68902 113.479 2.65998 113.524 2.63007C113.636 2.56838 113.636 2.56838 113.805 2.5677Z" fill="#3595F5"/>
            <path d="M116.11 2.56055C116.351 2.65252 116.527 2.72944 116.742 2.86866C116.825 2.9224 116.825 2.9224 116.91 2.97723C116.999 3.03523 116.999 3.03523 117.09 3.0944C117.183 3.15491 117.183 3.15491 117.278 3.21663C117.755 3.52645 118.228 3.84283 118.7 4.16145C119.191 4.49198 119.687 4.81163 120.184 5.12859C120.24 5.16462 120.297 5.20065 120.355 5.23778C120.43 5.2856 120.43 5.2856 120.507 5.33439C120.621 5.41062 120.621 5.41062 120.678 5.47558C120.684 5.62489 120.686 5.77441 120.687 5.92388C120.687 5.97131 120.687 6.01875 120.687 6.06762C120.688 6.22776 120.688 6.3879 120.689 6.54805C120.689 6.66237 120.69 6.77669 120.69 6.89101C120.691 7.20237 120.692 7.51373 120.693 7.82509C120.694 8.15011 120.695 8.47513 120.697 8.80014C120.699 9.41606 120.701 10.032 120.703 10.6479C120.705 11.3489 120.708 12.0499 120.71 12.7509C120.716 14.1934 120.721 15.6358 120.725 17.0783C120.804 17.1073 120.804 17.1073 120.884 17.137C121.069 17.2094 121.226 17.3008 121.396 17.4102C121.461 17.4512 121.525 17.4922 121.591 17.5344C121.661 17.5792 121.73 17.624 121.8 17.6688C121.873 17.7154 121.946 17.762 122.018 17.8086C122.17 17.9053 122.321 18.0022 122.473 18.0993C122.788 18.3014 123.105 18.5015 123.422 18.7018C124.107 19.1351 124.79 19.5709 125.474 20.0076C125.709 20.1577 125.944 20.3075 126.179 20.457C126.321 20.5475 126.464 20.6381 126.606 20.7288C126.674 20.7722 126.743 20.8156 126.811 20.859C126.905 20.9188 127 20.9788 127.094 21.0387C127.174 21.09 127.174 21.09 127.257 21.1423C127.379 21.2235 127.379 21.2235 127.435 21.2884C127.441 21.451 127.444 21.6119 127.444 21.7745C127.444 21.8254 127.444 21.8762 127.444 21.9287C127.445 22.0976 127.445 22.2665 127.445 22.4355C127.446 22.5523 127.446 22.6691 127.447 22.786C127.448 23.0941 127.448 23.4021 127.449 23.7102C127.45 24.0244 127.451 24.3385 127.452 24.6526C127.454 25.2695 127.455 25.8863 127.457 26.5031C127.249 26.46 127.098 26.4029 126.915 26.2805C126.84 26.2308 126.84 26.2308 126.764 26.1801C126.71 26.144 126.656 26.1079 126.601 26.0706C126.119 25.7526 125.635 25.4437 125.145 25.1435C124.625 24.8241 124.11 24.4962 123.597 24.1609C123.157 23.8733 122.712 23.5947 122.266 23.3194C121.757 23.0048 121.253 22.681 120.747 22.3582C120.755 24.4232 120.764 26.4882 120.772 28.6158C120.884 28.6584 120.995 28.7009 121.11 28.7448C121.199 28.796 121.287 28.8503 121.373 28.9075C121.423 28.9401 121.473 28.9726 121.524 29.0062C121.603 29.0592 121.603 29.0592 121.685 29.1133C121.801 29.1899 121.918 29.2665 122.035 29.3431C122.126 29.4031 122.126 29.4031 122.219 29.4644C122.532 29.6686 122.847 29.8687 123.161 30.0688C123.653 30.382 124.144 30.6962 124.635 31.0122C125.123 31.3266 125.611 31.6396 126.101 31.9515C126.648 32.3004 127.195 32.6508 127.74 33.0026C128.046 33.1991 128.351 33.3949 128.657 33.5897C128.689 33.6105 128.722 33.6313 128.756 33.6527C128.911 33.7513 129.066 33.8499 129.221 33.9483C129.81 34.3233 130.393 34.7092 130.979 35.0934C130.986 36.8358 130.993 38.5781 131 40.3733C130.809 40.2859 130.643 40.2027 130.465 40.091C130.417 40.0607 130.368 40.0304 130.319 39.9992C130.267 39.9665 130.215 39.9337 130.162 39.9C130.107 39.8656 130.052 39.8312 129.996 39.7957C129.5 39.4825 129.007 39.1625 128.514 38.8415C128.171 38.618 127.827 38.3964 127.483 38.1752C127.424 38.1376 127.366 38.1 127.306 38.0612C127.128 37.9467 126.949 37.8322 126.771 37.7177C126.031 37.2421 125.291 36.7656 124.553 36.2856C124.156 36.0274 123.758 35.7709 123.359 35.515C122.908 35.2248 122.456 34.9334 122.006 34.6405C121.321 34.1951 120.635 33.7536 119.948 33.3124C119.204 32.8347 118.461 32.3566 117.72 31.8735C117.223 31.5504 116.725 31.2337 116.226 30.9155C116.188 21.5583 116.15 12.2012 116.11 2.56055Z" fill="#3595F5"/>
            <path d="M152.878 40L139.623 4.04764H144.332L155.045 34.6184H155.145L165.858 4.04764H170.567L157.313 40H152.878ZM178.63 40.4983C171.18 40.4983 166.696 35.2911 166.696 27.1439V27.1189C166.696 19.0963 171.28 13.5901 178.356 13.5901C185.432 13.5901 189.742 18.8472 189.742 26.6206V28.2152H171.081C171.18 33.547 174.12 36.6614 178.729 36.6614C182.018 36.6614 184.335 35.017 185.083 32.7996L185.158 32.5753H189.418L189.368 32.8245C188.521 37.1099 184.286 40.4983 178.63 40.4983ZM178.331 17.427C174.569 17.427 171.629 19.9932 171.155 24.8268H185.332C184.908 19.7939 182.118 17.427 178.331 17.427ZM191.576 40V14.0884H195.911V17.7758H196.011C197.406 15.3591 200.047 13.5901 203.983 13.5901C209.664 13.5901 212.953 17.2775 212.953 23.1824V40H208.618V23.9547C208.618 19.7441 206.649 17.427 202.663 17.427C198.577 17.427 195.911 20.3421 195.911 24.752V40H191.576ZM224.354 40.4983C219.595 40.4983 217.253 38.3556 217.253 33.3975V17.6762H213.466V14.0884H217.253V7.08727H221.738V14.0884H226.671V17.6762H221.738V33.3726C221.738 36.1382 222.959 36.9105 225.276 36.9105C225.799 36.9105 226.297 36.8358 226.671 36.8109V40.3239C226.123 40.3986 225.201 40.4983 224.354 40.4983ZM237.624 40.4983C231.943 40.4983 228.654 36.8109 228.654 30.906V14.0884H232.989V30.1337C232.989 34.3443 234.958 36.6614 238.944 36.6614C243.03 36.6614 245.696 33.7463 245.696 29.3364V14.0884H250.031V40H245.696V36.3126H245.596C244.201 38.7293 241.56 40.4983 237.624 40.4983ZM253.136 40V14.0884H257.471V18.4734H257.571C258.443 15.4836 260.685 13.5901 263.6 13.5901C264.347 13.5901 264.995 13.7147 265.344 13.7645V17.9751C264.995 17.8506 264.073 17.726 263.027 17.726C259.663 17.726 257.471 20.068 257.471 24.0046V40H253.136ZM275.749 40.4983C268.299 40.4983 263.814 35.2911 263.814 27.1439V27.1189C263.814 19.0963 268.399 13.5901 275.474 13.5901C282.55 13.5901 286.861 18.8472 286.861 26.6206V28.2152H268.199C268.299 33.547 271.239 36.6614 275.848 36.6614C279.137 36.6614 281.454 35.017 282.202 32.7996L282.276 32.5753H286.537L286.487 32.8245C285.64 37.1099 281.404 40.4983 275.749 40.4983ZM275.45 17.427C271.687 17.427 268.747 19.9932 268.274 24.8268H282.451C282.027 19.7939 279.237 17.427 275.45 17.427ZM312.304 40.598C302.313 40.598 295.885 33.3228 295.885 22.0114V21.9864C295.885 10.675 302.288 3.44968 312.304 3.44968C319.778 3.44968 325.584 7.98421 326.954 14.786L327.004 15.0352H322.469L322.295 14.487C320.9 10.1269 317.362 7.58557 312.304 7.58557C305.128 7.58557 300.494 13.2413 300.494 21.9864V22.0114C300.494 30.7565 305.153 36.4621 312.304 36.4621C317.337 36.4621 320.825 33.9706 322.394 29.2367L322.469 29.0125H327.004L326.954 29.2616C325.584 36.1382 319.828 40.598 312.304 40.598ZM336.661 40.4983C331.503 40.4983 328.04 37.3839 328.04 32.675V32.6252C328.04 28.2152 331.478 25.4496 337.433 25.1008L344.858 24.6773V22.5097C344.858 19.3455 342.79 17.427 339.177 17.427C335.839 17.427 333.746 19.0216 333.247 21.3387L333.198 21.5629H329.012L329.037 21.2888C329.41 17.0284 333.123 13.5901 339.227 13.5901C345.356 13.5901 349.193 16.9038 349.193 22.0861V40H344.858V35.7894H344.758C343.238 38.6297 340.124 40.4983 336.661 40.4983ZM332.475 32.675C332.475 35.1665 334.518 36.7361 337.632 36.7361C341.718 36.7361 344.858 33.9207 344.858 30.1586V28.0408L337.931 28.4644C334.468 28.6637 332.475 30.2084 332.475 32.6252V32.675ZM352.148 48.7203V14.0884H356.483V18.4734H356.583C358.202 15.4587 361.092 13.5901 364.805 13.5901C371.432 13.5901 375.817 18.8721 375.817 27.0442V27.0691C375.817 35.2412 371.382 40.4983 364.879 40.4983C361.217 40.4983 358.202 38.6546 356.583 35.6648H356.483V48.7203H352.148ZM363.958 36.6614C368.542 36.6614 371.382 32.974 371.382 27.0691V27.0442C371.382 21.0895 368.542 17.427 363.958 17.427C359.573 17.427 356.458 21.239 356.458 27.0442V27.0691C356.458 32.8494 359.598 36.6614 363.958 36.6614ZM380.093 9.70335C378.598 9.70335 377.377 8.48251 377.377 6.98761C377.377 5.4678 378.598 4.27188 380.093 4.27188C381.612 4.27188 382.808 5.4678 382.808 6.98761C382.808 8.48251 381.612 9.70335 380.093 9.70335ZM377.925 40V14.0884H382.26V40H377.925ZM394.035 40.4983C389.276 40.4983 386.934 38.3556 386.934 33.3975V17.6762H383.147V14.0884H386.934V7.08727H391.419V14.0884H396.352V17.6762H391.419V33.3726C391.419 36.1382 392.64 36.9105 394.957 36.9105C395.48 36.9105 395.978 36.8358 396.352 36.8109V40.3239C395.804 40.3986 394.882 40.4983 394.035 40.4983ZM405.536 40.4983C400.378 40.4983 396.915 37.3839 396.915 32.675V32.6252C396.915 28.2152 400.353 25.4496 406.308 25.1008L413.733 24.6773V22.5097C413.733 19.3455 411.665 17.427 408.052 17.427C404.714 17.427 402.621 19.0216 402.122 21.3387L402.073 21.5629H397.887L397.912 21.2888C398.286 17.0284 401.998 13.5901 408.102 13.5901C414.231 13.5901 418.068 16.9038 418.068 22.0861V40H413.733V35.7894H413.633C412.113 38.6297 408.999 40.4983 405.536 40.4983ZM401.35 32.675C401.35 35.1665 403.393 36.7361 406.507 36.7361C410.594 36.7361 413.733 33.9207 413.733 30.1586V28.0408L406.806 28.4644C403.343 28.6637 401.35 30.2084 401.35 32.6252V32.675ZM421.247 40V4.04764H425.582V40H421.247Z" fill="#090925"/>
          </svg>
        </div>
      </router-link>

      <div class="right">
        <span>{{ titlePage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidenav from "./Navigation/TheSidenav.vue";

export default {
  components: { TheSidenav },
  props: {
    showNavbar: { type: Boolean, default: false },
  },
  data() {
    return {
      displayMenu: false,
      backgroundColor: "#fff",
      color: "#000",
    };
  },
  watch: {
    displayMenu() {
      const body = document.querySelector("body");
      body.classList.toggle("disable-scroll");
    },
  },
  computed: {
    isLogoBlackColor() {
      if (this.isFuelLogoBlack) return true;
      return false;
    },

    styleHeader() {
      return { color: "#000", backgroundColor: "#fff" };
    },
    titlePage() {
      const titleList = {
        Home: "WELCOME TO FUEL",
        Funds: "FUNDS",
        "Our Team": "OUR TEAM",
        "Who We Are": "WHO WE ARE",
        "Fuel The Mind": "FUEL THE MIND",
        "Fueling the future": "Fueling the future",
        Portfolio: "PORTFOLIO",
        Page1: "WELCOME TO FUEL",

      };
      return titleList[this.$route.name] || "";
    },
  },
  methods: {
    redirectToHome() {
      window.scrollTo({ top: 0, behavior: "instant" });
    },
    showMenu() {
      this.displayMenu = !this.displayMenu;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-page {
  font-family: "SF Pro Text";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  overflow: hidden;

  z-index: 998;
  transition: all 0.6s;
  &.scrollUp {
    transform: translateY(-84px);
  }

  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding-top: 14px;
    padding-bottom: 14px;
  }

  .left {
    display: flex;
    align-items: center;
    z-index: 6;

    .img {
      width: 300px;
      height: 46px;
      fill: inherit;

      margin: 0;
      font-family: inherit;
      font-size: 16px;
      font-weight: 400;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .hamburger {
    height: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    @media screen and (min-width: 576px) {
      min-width: 220px;
    }

    .menu {
      z-index: 1201;
    }

    span {
      background-color: #fff;
      content: "";
      display: block;
      position: relative;
      transition: background-color 0.2s ease-in-out, top 0.2s 0.2s ease-out,
        transform 0.2s linear;

      &:before,
      &:after {
        background-color: inherit;
        color: inherit;
        content: "";
        display: block;
        height: 2px;
        position: absolute;
        transform-origin: 50% 50%;
        transition: background-color 0.2s ease-in-out, top 0.2s 0.2s ease-out,
          transform 0.2s linear;
        width: 26px;
      }

      &:before {
        top: 7px;
      }

      &:after {
        top: -7px;
      }
    }

    &.active {
      span {
        z-index: 1200;
        background-color: #fff;
        transition: background-color 0.2s ease-out;

        &:before,
        &:after {
          background-color: inherit;
          transition: top 0.2s ease-out, transform 0.2s 0.2s ease-out;
        }

        &:before {
          top: 0;
          transform: rotate3d(0, 0, 1, -45deg);
        }

        &:after {
          top: 0;
          transform: rotate3d(0, 0, 1, 45deg);
        }
      }
    }
  }

  .right {
    display: none;

    @media screen and (min-width: 576px) {
      min-width: 220px;
      display: flex;
      justify-content: flex-end;
    }

    span {
      color: inherit;
      font-family: inherit;
      font-size: 18px;
      font-weight: 400;
      padding: 0;

      @media screen and (min-width: 992px) {
        font-size: 22px;
      }
    }
  }
}

.active {
  .style-black {
    stroke: #000 !important;
    .menu {
      color: #000 !important;
    }
  }
}

.style-black {
  stroke: #000;

  .menu {
    font-size: 18px;

    color: #000;
    @media screen and (min-width: 992px) {
      font-size: 22px;
    }
  }
}

.style-white {
  stroke: #fff;
}

.hamburger-svg {
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
  z-index: 1201;
  margin-right: 10px;

  .line {
    fill: none;
    stroke: inherit;
    stroke-width: 3;
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
      stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .line1 {
    stroke-dasharray: 60 207;
    stroke-width: 4;
  }
  .line2 {
    stroke-dasharray: 60 60;
    stroke-width: 4;
  }
  .line3 {
    stroke-dasharray: 60 207;
    stroke-width: 4;
  }
}

.opened {
  .line1 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 4;
  }

  .line2 {
    stroke-dasharray: 1 60;
    stroke-dashoffset: -30;
    stroke-width: 4;
  }

  .line3 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 4;
  }
}
</style>
